import React from 'react';
import { Database, Brain, Target } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: <Database size={48} style={{ color: '#8d1300' }} />,
      title: "1. Conecta tu Realidad Operativa",
      description: "Centraliza tu información de manera ágil y segura. Ya sea importando archivos locales (CSV, Excel) o mediante una conexión directa a tu base de datos, la plataforma organiza tus datos para convertirlos en una base de conocimiento sólida y lista para el análisis."
    },
    {
      icon: <Brain size={48} style={{ color: '#8d1300' }} />,
      title: "2. Nuestro Motor IA Encuentra la Causa-Efecto",
      description: "El motor de Gestas ML ha sido entrenado meticulosamente con datos productivos reales para entender las variables que de verdad importan. Su inteligencia se dedica a un minucioso trabajo de investigación sobre tus propios datos, identificando las conexiones y patrones únicos de tu operación que conducen a mejores resultados."
    },
    {
      icon: <Target size={48} style={{ color: '#8d1300' }} />,
      title: "3. Tu Estrategia, Clarificada",
      description: "El resultado es un plan de acción dirigido. La plataforma convierte los análisis complejos en recomendaciones claras y listas para implementar, permitiéndote tomar decisiones estratégicas de forma inmediata y con total confianza."
    }
  ];

  return (
    <section className="how-it-works-section">
      <h2 className="section-title">¿Cómo Funciona Gestas ML?</h2>
      <p className="section-subtitle">
        Un proceso diseñado para ser eficiente, transparente y, sobre todo, útil.
      </p>
      <div className="steps-container">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-icon-container">
              {step.icon}
            </div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorksSection;